import React from 'react';
import { guardarMeasure } from '../firebase';
import { Alcance } from '../Alcance';
import { yearMeasure } from '../pages/Home';

function MedirEnergiaElectrica ( props ) {
    const sub = props.sub
    const meses = [ "Enero","Febrero","Marzo","Abril","Mayo","Junio","Julio",
                        "Agosto","Septiembre","Octubre","Noviembre","Diciembre"]

    const [alcance, setAlcance] = React.useState(2);
    const [nombreEntrada, setNombreEntrada] = React.useState('Oficinas');
    const [horasDia, setHorasDia] = React.useState(1);
    const [diasYear, setDiasYear] = React.useState(1);
    const [nombreDispositivo, setNombreDispositivo] = React.useState('');
    const [cantidadDispositivos, setCantidadDispositivos] = React.useState(1);
    const [consumoEnergiaHora, setConsumoEnergiaHora] = React.useState();
    const [marcaReferenciaDispositivo, setMarcaReferenciaDispositivo] = React.useState('');
    const [unidadConsumoEnergia, setUnidadConsumoEnergia] = React.useState('kWh');
    //const [potenciaDispositivo, setPotenciaDispositivo] = React.useState(0);
    const [unidadPotencia, setUnidadPotencia] = React.useState('');
    const [classValida, setClassValida] = React.useState('class__valida__red');
    const [isCargado, setIsCargado] = React.useState(false);

    const [tipoRegistro, setTipoRegistro] = React.useState('Factura')
    const [facturaMes, setFacturaMes] = React.useState('Enero')
    const [kwhFactura, setKwhFactura] = React.useState(0)
    //const [yearSeleccionado, setYearSeleccionado] = React.useState(props.year);
    
    const handleNombreEntrada = (event) => {
        console.log('NombreEntrada: '+event.target.value);
        setNombreEntrada(event.target.value);
    }
    const onClickSelectNombre =(event)=>{
        setClassValida('class__valida__green')
        setNombreEntrada(event.target.value);
    }
    /*const handleHorasDia = (event) => {
        console.log('UHoras dia: '+horasDia);
        setHorasDia(event.target.value);
    }
    const handleDiasYear = (event) => {
        console.log('Udias year: '+diasYear);
        setDiasYear(event.target.value);
    }
    const handlePotenciaDispositivo = (event) => {
        setPotenciaDispositivo(event.target.value);
        console.log('potenciaDispositivo: '+potenciaDispositivo);
    }
    const handleConsumoEnergiaHora = (event) => {
        setConsumoEnergiaHora(event.target.value);
        console.log('consumoEnergiaHora: '+consumoEnergiaHora);
    }
    const handleCantidadDispositivos = (event) => {
        setCantidadDispositivos(event.target.value);
        console.log('cantidadDispositivos: '+cantidadDispositivos);
    }
        const handleAlcance = (event) => {
        setAlcance(event.target.value);
        console.log('Alcance: '+event.target.value);
    }
    const handleUnidadConsumoEnergia = (event) => {
        setUnidadConsumoEnergia(event.target.value);
        console.log('unidadConsumoEnergia: '+unidadConsumoEnergia);
    }*/

    const handleUnidadPotencia = (event) => {
        setUnidadPotencia(event.target.value);
    }

    const handleMarcaReferenciaDispositivo = (event) => {
        setMarcaReferenciaDispositivo(event.target.value);
    }
    const handleNombreDispositivo = (event) => {
        setNombreDispositivo(event.target.value);
    }

    const onSubmit = async (event) => {
        event.preventDefault();
        const fecha_modificacion = new Date().toUTCString();
        let measure = {}
        if (tipoRegistro === 'Factura') {
            console.log(sub.fe_factura)
            let resultado_kgco2 = Number(kwhFactura) * Number(sub.fe_factura);
            console.log(resultado_kgco2)
            measure = {
                categoria: sub.nombre,
                subcategoria: sub.nombre,
                alcance: Number(alcance),
                empresa: 'Fibtex',
                fe: Number(sub.fe),
                nombre: nombreEntrada,
                resultado_kgco2: resultado_kgco2,
                consumo_energia_anual_kwh: Number(kwhFactura),
                referencia_producto: tipoRegistro +' '+ facturaMes,
                user_email: props.user.email,
                year: yearMeasure,
                fecha_modificacion: fecha_modificacion
            }
        }else{
            let tiempo_horas_year = horasDia * diasYear;
            let consumo_energia_anual_kwh = tiempo_horas_year * cantidadDispositivos * consumoEnergiaHora;
            let consumo_energia_anual_mwh = consumo_energia_anual_kwh / 1000;
            let resultado_tco2 = consumo_energia_anual_mwh * sub.fe;

            measure = {
                categoria: sub.nombre,
                alcance: alcance,
                horas_dia: horasDia,
                dias_year: diasYear,
                tiempo_horas_year: tiempo_horas_year,
                nombre_dispositivo: nombreDispositivo,
                empresa: 'Fibtex',
                fe: sub.fe,
                cantidad_dispositivos: cantidadDispositivos,
                nombre: nombreEntrada,
                consumo_energia_hora_kwh: consumoEnergiaHora,
                consumo_energia_anual_kwh: consumo_energia_anual_kwh,
                consumo_energia_anual_mwh: consumo_energia_anual_mwh,
                referencia_producto: marcaReferenciaDispositivo,
                resultado_kgco2: resultado_tco2,
                unidad_consumo_energia: unidadConsumoEnergia,
                subcategoria: sub.nombre,
                //potencia_dispositivo: potenciaDispositivo,
                unidad_potencia: unidadPotencia,
                user_email: props.user.email,
                year: yearMeasure,
                fecha_modificacion: fecha_modificacion
            }
        }
        enviarGuardado(measure)
    }

    const cerrarInfo=()=>{
        setIsCargado(false);
    }
    const enviarGuardado = async (measure) =>{
        const result = await guardarMeasure(measure);
        if (result) {
            console.log(result);
            console.log('limpiar inputs ');
            setHorasDia('')
            setDiasYear('')
            setNombreDispositivo('')
            setCantidadDispositivos('')
            setConsumoEnergiaHora('')
            setMarcaReferenciaDispositivo('')
            setUnidadConsumoEnergia('')
            setConsumoEnergiaHora();
            setHorasDia(0)
            setDiasYear(0)
            setIsCargado(true);
            setKwhFactura(0);
            setFacturaMes('Enero')
        }else{
            alert('Ocurrió un error inesperado, por favor refresque la página e intente de nuevo.')
        }
    }
    const onClickTipoRegistro = (e) => {
        setTipoRegistro(e.target.value)
    }

    return (
        <div>
        { isCargado &&
            <div className='entrada__ingresada'>
            <div className='items__ingresada'>
                <h4 style={{background:'transparent'}}  >Registro ingresado correctamente</h4>
                <button className='items__ingresado__button' onClick={cerrarInfo}>Aceptar</button>
            </div>
            </div>
        }
        <h2 style={{ whiteSpace:'pre-line', textAlign:'center'}}>Subcategoría consumo de energía</h2>
            <form onSubmit={onSubmit}>
                <div className="form-group">
                    <label>Nombre subcategoría</label>
                    <select id='selectNombre' className={classValida} style={{borderRadius:'1.25rem',display:'block',width:'60%',padding:'0.375rem 0.75rem'}} 
                        onChange={handleNombreEntrada}
                        onClick={onClickSelectNombre}>
                        <option value='Oficinas' >Oficinas</option>
                        <option value='Planta' >Planta</option>
                    </select>
                </div>

                <div className='form-group'>
                    <label>Año seleccionado</label>
                    <label className='year__seleccionado' value={yearMeasure} >{yearMeasure}</label>
                </div>
                <div className='form-group'>
                    <label>Alcance</label>
                    <Alcance value={alcance} onChange={e=> setAlcance(e.target.value)}></Alcance>
                </div>
                
                <div className="form-group">
                    <label>Tipo registro</label>
                    <select id='selectNombre' className={classValida} style={{borderRadius:'1.25rem',display:'block',width:'60%',padding:'0.375rem 0.75rem'}} 
                        onChange={ (e) => setTipoRegistro(e.target.value) }>
                        <option value='Factura' >Registro por factura</option>
                        <option value='Maquina' >Registro por máquina</option>
                    </select>
                </div>
                
                { (tipoRegistro === 'Maquina') ? 
                    <div>
                        <div className="form-group">
                            <label>Nombre del dispositivo o máquina</label>
                            <label style={{ float:'right',marginRight:'5%' }}>Cantidad dispositivos</label>
                            <br/>
                            <input style={{ borderRadius:'1.25rem',width:'60%',padding:'0.375rem 0.75rem',border:'1px solid #ced4da'}} type="text" className="" value={nombreDispositivo} onChange={handleNombreDispositivo} placeholder="Nombre dispositivo o máquina" />
                            <input required type="number" 
                                className="form-control" 
                                placeholder="Cantidad dispositivos"
                                onInvalid={(e) => e.target.setCustomValidity("Por favor ingrese la cantidad de dispositivos!")}
                                onInput={(e) => e.target.setCustomValidity('')} 
                                value={cantidadDispositivos} 
                                onChange={e => setCantidadDispositivos(e.target.value)}
                                style={{ float:'right',marginRight:'8%',borderRadius:'1.25rem',padding:'0.375rem 0.75rem',width:'15%',border:'1px solid #ced4da'}} 
                            />
                        </div>
                        <div className="form-group">
                            <label>Marca o referencia</label>
                            <input type="text" className="form-control" value={marcaReferenciaDispositivo} onChange={handleMarcaReferenciaDispositivo} placeholder="Marca o referencia dispositivo" />
                        </div>
                        {/*<div className="form-group">
                           <label>Consumo energía hora kWh</label> <label style={{ float:'right',marginRight:'11%' }}>Unidad</label>
                           <br/>
                           <input pattern="[0-9]\d*\,?\d*$" style={{ borderRadius:'1.25rem',width:'20%',padding:'0.375rem 0.75rem',border:'1px solid #ced4da'}} type="text"  value={consumoEnergiaHora} onChange={handleConsumoEnergiaHora} placeholder="Consumo" />
                        
                            <select style={{ float:'right',marginRight:'8%',borderRadius:'1.25rem',padding:'0.375rem 0.75rem',width:'12%',border:'1px solid #ced4da'}} value={unidadConsumoEnergia} onChange={handleUnidadConsumoEnergia}>
                               <option value="kWh">kWh</option>
                              <option value="MWh">MWh</option>
                          </select>    
                        </div>*/}
                        <div className="form-group">
                            <label>Consumo energía hora</label> <label style={{ float:'right',marginRight:'6%' }}>Unidad energía</label>
                            <br/>
                            <input type="number" step='0.01' 
                                className="form-control" 
                                placeholder="Consumo energía"
                                value={consumoEnergiaHora} 
                                onChange={(e) => setConsumoEnergiaHora(e.target.value)}
                                style={{ borderRadius:'1.25rem',width:'20%',padding:'0.375rem 0.75rem',border:'1px solid #ced4da'}} />

                            <select style={{ float:'right',marginRight:'8%',borderRadius:'1.25rem',padding:'0.375rem 0.75rem',width:'18%',border:'1px solid #ced4da'}} 
                                    value={unidadConsumoEnergia} 
                                    onChange={(e) => setUnidadConsumoEnergia(e.value.target)}>
                                <option value="kWh">kWh</option>
                                <option value="MWh">MWh</option>
                            </select>
                        </div>
                        
                        <div className="form-group">
                            <label>Horas uso día</label><br/>
                            <div style={{ marginTop:'30px'}}>
                                <input style={{ width:'100%'}} className="slider" type="range" min="0" max="24" step="1"  value={horasDia} onChange={e=> setHorasDia(e.target.value)} />
                                <div style={{ width:'100%'}}>
                                    <label style={{background:'white',border: '1px solid gray', position:'relative',top:'-47px',width:'29px',textAlign:'center',borderRadius:'15px',left:`calc(${ Number( (horasDia - 0) * 100 / (24 - 0) ) }% - (${ (horasDia / 2)}px))` }}>{horasDia}</label>
                                </div>
                            </div>
                        </div>
                        <div className="form-group">
                        <label>Días uso año</label><br/>
                            <div style={{ marginTop:'30px'}}>
                            <input style={{ width:'100%'}} className="slider" type="range" min="0" max="365" step="1"  value={diasYear} onChange={e=> setDiasYear(e.target.value)} />
                                <div style={{ width:'100%'}}>
                                    <label style={{background:'white',border: '1px solid gray',position:'relative',top:'-47px',width:'35px',textAlign:'center',borderRadius:'15px',left:`calc(${ Number( (diasYear - 0) * 100 / (365 - 0) ) }% - (${ (diasYear / 30)}px))` }}>{diasYear}</label>
                                </div>
                            </div>
                        </div>
                    </div>
                    :
                    <div>
                        <h3>Ingresar datos según factura de energía.</h3>
                        <div className="form-group">
                            <label>Consumo en kilovatios/hora según factura</label><br/>
                            <input  style={{ width:'30%'}} 
                                    className="form-control" 
                                    type="number" step="0.01" 
                                    value={kwhFactura} 
                                    onChange={ (e) => setKwhFactura(e.target.value) } 
                                    placeholder="Ingrese el consumo en kWh de su factura"
                                />
                        </div>
                        <div className="form-group">
                            <label>Mes factura</label><br/>
                            <select style={{ borderRadius:'1.25rem',display:'block',width:'30%',padding:'0.375rem 0.75rem'}} 
                                    value={facturaMes} 
                                    onChange={ (e) => setFacturaMes(e.target.value) } >
                                {
                                    meses.map((mes) => {
                                        return <option key={mes} value={mes}>{mes}</option>
                                    })
                                }
                            </select>
                            
                        </div>
                    </div>}

                
                <button className='boton__agregar__entrada'>
                    Agregar nueva entrada
                </button>
            </form>
        </div>
                
    )
}

export { MedirEnergiaElectrica }
